<div class="screen-element toast-screen" [class.tli-font]="hasParameter('tliFont')">
	<div *ngIf="showIconBar" class="iconbar">
		<iconbar></iconbar><!--<span *ngIf="menuIcon" class="menu-icon inline-icon {{menuIcon}}">&nbsp;</span>-->
	</div>
	<div class="title"
		[ngClass]="{'darkTitle':hasParameter('darkTitle')||hasParameter('darkTitleOnly'),'darkerTitle':hasParameter('darkerTitle')||hasParameter('darkerTitleOnly')}">
		{{title}}
		@if(titleIcon() != ''){
		<span class="menu-icon inline-icon {{titleIcon()}}">&nbsp;</span>
		}
	</div>
	<div *ngIf=" !hasParameter('normalCaseSubtitle')" class="subtitle"
		[ngClass]="{'darkTitle':hasParameter('darkTitle'),'darkerTitle':hasParameter('darkerTitle'),'light':hasParameter('lightSubtitle')}">
		{{getSubtitle()|uppercase}}

	</div>
	<div *ngIf="hasParameter('normalCaseSubtitle')" class="subtitle"
		[ngClass]="{'darkTitle':hasParameter('darkTitle'),'darkerTitle':hasParameter('darkerTitle'),'light':hasParameter('lightSubtitle')}">
		{{getSubtitle()}}</div>
	<div class="dashboard-center">
		<div *ngIf="value !== undefined" class="value" [ngClass]="{ 'small' : hasParameter('smallValue') }">
			{{value}}<ng-container *ngIf="largeUnit">{{unit}}</ng-container>
		</div>
		<div *ngIf="unit&&!largeUnit" class="unit">{{unit}}</div>
		<div *ngIf="dashIcon" class="icon {{dashIcon}}"
			[ngClass]="{'bigDashIcon':hasParameter('bigDashIcon'),'veryBigDashIcon':hasParameter('veryBigDashIcon')}">
		</div>
	</div>
	<div class="text text-1"><text-widget [tliFont]="hasParameter('tliFont')" [color]="getColor(1)"
			[text]="getText(0)"></text-widget></div>
	<div class="text text-2"><text-widget [tliFont]="hasParameter('tliFont')" [color]="getColor(2)"
			[text]="getText(1)"></text-widget></div>
	<div class="text text-3"><text-widget [tliFont]="hasParameter('tliFont')" [color]="getColor(3)"
			[text]="getText(2)"></text-widget></div>
	<!--
	<div class="text text-1">{{menuService.getText(0)}}</div>
	<div class="text text-2">{{menuService.getText(1)}}</div>
	<div *ngIf="!menuService.hasParameter('yes-no-button')" class="text text-3">{{menuService.getText(2)}}</div>
	<div *ngIf="menuService.hasParameter('yes-no-button')" class="text text-3">
		<span class="inline-icon iconBack vaillant-grey-50">&nbsp;</span><span class="vaillant-grey-50">Nein</span>&nbsp;
		<span class="inline-icon iconCheckConfirm vaillant-grey-50">&nbsp;</span><span class="vaillant-grey-50">Ja</span>
	</div>
	-->
</div>